module.exports = __webpack_public_path__ + "img/117.d589eb1e.jpg";